//Dependencies
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Modal, Typography } from "antd";

//Components
import { GeneralInput } from "../../GenericComponents/InputComponent/generalInput";
import { YesNoButton } from "../../GenericComponents/buttons/yesNoButton";
import { setVmSetupWithMeasurementUnit } from "../../../Utils/LanguageLocalization/vmSetupMeasurementUnit";

// Actions
import { updateVmSetupById, listAllCurrencyCodes, listCountries, listLanguages } from "../../../actions";

//Language localization
import Strings from "../../../systemVariables/languageStrings";

const { Text } = Typography;

class VendingMachineUpdateSetupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setupVar: null,
      setupVarNewValue: null,
      isNewValValid: false,
      loading: false,
      isNewValSet: false,
      isUpdateButtonDisabled: false,
      booleanButtonStatus: null,
      optionList:[],
      options: "",
    };
  }

  componentDidUpdate() {
    //Update state variables from parent props
    if (this.props.vmSetupSel != null && this.state.setupVar !== this.props.vmSetupSel) {
      this.setState({
        setupVar: this.props.vmSetupSel,
        booleanButtonStatus: this.props.vmSetupSel.measurementUnit === "boolean" && this.props.vmSetupSel.stringValue === "1",
        options: "",
        optionList:[],
      });
      if (this.props.vmSetupSel.name === "CURRENCY CODE"){
        this.props.listAllCurrencyCodes((response) => {
          this.setState({
            optionList: response.data.data,
            options: response.data.data.map(item => item.currencyAlphaCode).join(', '),
          });
        });
      }
      if (this.props.vmSetupSel.name === "COUNTRY CODE"){
        this.props.listCountries((response) => {
          this.setState({
            optionList: response.data.data,
            options: response.data.data.map(item => item.alpha2Code).join(', '),
          });
        });
      }
      if (this.props.vmSetupSel.name === "LANGUAGE"){
        this.props.listLanguages((response) => {
          this.setState({
            optionList: response.data.data,
            options: response.data.data.map(item => item.languageCode).join(', '),
          });
        });
      }
    }
  }

  handleOk = () => {

    if (this.props.vmSetupSel.measurementUnit !== "boolean") {
      let isValid = true;
      if (this.props.vmSetupSel.name === "CURRENCY CODE"){
        isValid = this.state.optionList.some(item => item.currencyAlphaCode === this.state.setupVarNewValue);
      }   
  
      if (this.props.vmSetupSel.name === "COUNTRY CODE"){
        isValid = this.state.optionList.some(item => item.alpha2Code === this.state.setupVarNewValue);
      }   
  
      if (this.props.vmSetupSel.name === "LANGUAGE"){
        isValid = this.state.optionList.some(item => item.languageCode === this.state.setupVarNewValue);
      }   

      if (this.props.vmSetupSel.name === "COUNTRY CALLING CODE"){
        isValid = this.state.setupVarNewValue === null ? false : true;
      }   

      console.log(this.props.vmSetupSel.regex);
      console.log(this.state.setupVarNewValue)

      if (this.props.vmSetupSel.name === "CUSTOMER SERVICE PHONE"){
        isValid = this.state.setupVarNewValue ===  null ? false : true;
      }   

      if(isValid){
        if (this.props.vmSetupSel.regex) {
          if (this.state.setupVarNewValue.match(this.props.vmSetupSel.regex)) {
            this.setState({
              isNewValValid: true,
              isNewValSet: false,
              isUpdateButtonDisabled: true,
              loading: true,
            });
            this.props.updateVmSetupById(this.props.vmSetupSel.id, String(this.state.setupVarNewValue), (response) => {
              this.setState({
                isNewValSet: true,
                loading: false, 
                isUpdateButtonDisabled: false,
              });
            });
          } else {
            this.setState({
              isNewValValid: false,
              isNewValSet: true,
              loading: false,
            });
          }
        } else if (this.props.vmSetupSel.min && this.props.vmSetupSel.max) {
          var min = parseInt(this.props.vmSetupSel.min);
          var max = parseInt(this.props.vmSetupSel.max);
          if (this.state.setupVarNewValue >= min && this.state.setupVarNewValue <= max) {
            this.setState({
              isNewValValid: true,
              isNewValSet: false,
              isUpdateButtonDisabled: true,
              loading: true,
            });
            this.props.updateVmSetupById(this.props.vmSetupSel.id, this.state.setupVarNewValue, (response) => {
              this.setState({
                isNewValSet: true,
                loading: false, 
                isUpdateButtonDisabled: false,
              });
            });
          } else {
            this.setState({
              isNewValValid: false,
              isNewValSet: true,
              loading: false,
            });
          }
        } else {
          this.setState({
            isNewValValid: true,
            isNewValSet: false,
            isUpdateButtonDisabled: true,
            loading: true,
          });
          this.props.updateVmSetupById(this.props.vmSetupSel.id, this.state.setupVarNewValue, (response) => {
            this.setState({
              isNewValSet: true,
              loading: false, 
              isUpdateButtonDisabled: false,
            });
          });
        }
      } else {
        this.setState({
          isNewValValid: false,
          isNewValSet: true,
          isUpdateButtonDisabled: false,
          loading: false,
        });
      }
    } else {
      var newVal = this.state.booleanButtonStatus ? 1 : 0;
      this.setState({
        isNewValValid: true,
        isNewValSet: false,
        isUpdateButtonDisabled: true,
        loading: true,
      });
      this.props.updateVmSetupById(this.props.vmSetupSel.id, newVal, (response) => {
        this.setState({
          isNewValSet: true,
          loading: false, 
          isUpdateButtonDisabled: false,
        });
      });
    }
  };

  handleCancel = () => {
    this.setState({
      setupVarNewValue: null,
      isNewValSet: false,
      isNewValValid: false,
      setupVar: null,
      isUpdateButtonDisabled: false,
      loading: false,
      optionList: [],
      options: "",
    });
    this.props.hideModal(this.state.isNewValValid);
  };

  handleSetupValChange = (val) => {
    this.setState({
      setupVarNewValue: val.target.value,
    });
  };

  handleBooleanSetupValChange = () => {
    this.setState({
      booleanButtonStatus: !this.state.booleanButtonStatus,
    });
  };

  render() {
    if (this.props.vmSetupSel == null) {
      return "";
    } else {
      return (
        <Modal
          title={Strings.vmSetup.editVmsetup}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText={Strings.generalTerms.update}
          okButtonProps={{ disabled: this.state.isUpdateButtonDisabled, loading: this.state.loading }}
          cancelText={!this.state.isNewValSet ? Strings.generalTerms.cancel : Strings.generalTerms.close}
          cancelButtonProps={{ disabled: this.state.isUpdateButtonDisabled }}
          width={650}
          visible={this.props.isVisible}
        >
          <Fragment>
            <div className="row">
              <div className="col-4" style={{ display:"flex", justifyContent: "center", alignItems: "center" }}>
                <b>{Strings.vmSetup.parameter + ":"}</b>
              </div>
              <div className="col-8" style={{ display:"flex", justifyContent: "center", alignItems: "center" }}>
                <Text>{this.props.vmSetupSel.name}</Text>
              </div>
            </div>
            <br />
            <div className="row">
            <div className="col-4" style={{ display:"flex", justifyContent: "center", alignItems: "center" }}>
                <b>{Strings.generalTerms.description + ":"}</b>
              </div>
              <div className="col-8" style={{ display:"flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                <Text>{this.props.vmSetupSel.description}</Text>
                <Text style={{fontWeight: "350px"}}>{this.state.options !== "" ? Strings.generalTerms.enterOneOfTheFollowingValues + ": " + this.state.options : null}</Text>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-4" style={{ display:"flex", justifyContent: "center", alignItems: "center" }}>
                <b>{Strings.vmSetup.currentValue + ": "}</b>
              </div>
              <div className="col-8" style={{ display:"flex", justifyContent: "center", alignItems: "center" }}>
                <span>{setVmSetupWithMeasurementUnit(this.props.vmSetupSel.stringValue, this.props.vmSetupSel.measurementUnit)}</span>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-4" style={{ display:"flex", justifyContent: "center", alignItems: "center" }}>
                <b>{Strings.vmSetup.newValue + ": "}</b>
              </div>
              <div className="col-8" style={{ display:"flex", justifyContent: "center", alignItems: "center" }}>
                {this.props.vmSetupSel.measurementUnit !== "boolean" ? (
                  <div className="col-12" style={{ display:"flex", justifyContent: "center", alignItems: "center" }}>
                    <GeneralInput value={this.state.setupVarNewValue} onChange={(val) => this.handleSetupValChange(val)} isReq={true}/>
                  </div>
                ) : (
                  <div className="col-12" style={{ display:"flex", justifyContent: "center", alignItems: "center" }}>
                    <YesNoButton status={this.state.booleanButtonStatus} onClick={this.handleBooleanSetupValChange}/>
                  </div>
                )}
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-12" style={{ display:"flex", justifyContent: "center", alignItems: "center", fontSize: "18px", color: this.state.isNewValValid ? "green" : "red"}} >
                {
                  this.state.isNewValSet ? (
                    !this.state.isNewValValid ? Strings.generalResponses.invalidValue : Strings.generalResponses.successfulUpdate
                  ): null
                }
              </div>
              <br/>
              <div className="col-12" style={{ display:"flex", justifyContent: "center", alignItems: "center", fontSize: "18px"}} >
                {
                  this.state.isNewValSet &&  this.state.isNewValValid ? (
                    Strings.generalResponses.closeTheModalToApplyTheChanges
                  ): null
                }
              </div>
            </div>
          </Fragment>
        </Modal>
      );
    }
  }
}

function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps, {
  updateVmSetupById,
  listAllCurrencyCodes,
  listLanguages,
  listCountries,
})(VendingMachineUpdateSetupModal);
